import { render, staticRenderFns } from "./TrustCheckerForm.vue?vue&type=template&id=39bb3cd5&"
import script from "./TrustCheckerForm.vue?vue&type=script&lang=js&"
export * from "./TrustCheckerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports